import {BijbError} from '../../models/bijb-error';
import {DressCodePicture} from '../../models/dress-code-picture';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class DressCodePicturesState extends LoadableState {
  public static readonly key = 'DressCodePicturesState';

  @autoserializeAs(DressCodePicture, 'dressCodePictures')
  public dressCodePictures: DressCodePicture[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
